import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {MatchesTabModel} from "../matches.tab-model";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitorMatchesPageLinkModel} from "../../../../../containers/competitor-container/pages/matches-page/models/competitor.matches-page.link-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";
import type {CompetitorViewModel} from "../../../../../domain/common/competitor/models/competitor-view-model";

export class CompetitorMatchesPageTabModel extends MatchesTabModel {
  index: Number;
  name: String;
  entity: CompetitorViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitorViewModel,
    currentLinkModel: BaseLinkModel,
    isWidget: BaseLinkModel
  ) {
    super(index, name, isWidget)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitorMatchesPageLinkModel {
    const linkModel: CompetitorMatchesPageLinkModel = new CompetitorMatchesPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, NEW_COMPETITOR_CONTAINER.FILTERS.matches, null, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === NEW_COMPETITOR_CONTAINER.FILTERS.matches;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competitor;
  }

  get elementId(): String {
    return 'navigation-tabs_competitor_matches';
  }
}
